import React from 'react';
import BlockPropertiesForm from './BlockPropertiesForm.jsx';

export default function InspectorPanel({
  block,
  onChange,
  onDelete,
  onDuplicate,
  onBringForward,
  onSendBackward,
}) {
  if (!block) {
    return (
      <div className="flex h-full min-h-0 flex-col rounded-xl border border-cyan-300/20 bg-[#061020]/70 p-3 text-xs text-slate-400">
        Pilih block pada canvas untuk mengubah propertinya.
      </div>
    );
  }

  return (
    <div className="flex h-full min-h-0 flex-col rounded-xl border border-cyan-300/20 bg-[#061020]/70 p-3 text-xs">
      <p className="mb-2 font-semibold uppercase tracking-[0.12em] text-cyan-200">Inspector</p>
      <BlockPropertiesForm
        block={block}
        onChange={onChange}
        onDelete={onDelete}
        onDuplicate={onDuplicate}
        onBringForward={onBringForward}
        onSendBackward={onSendBackward}
      />
    </div>
  );
}
